export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5237.110cb59a.jpg";